var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicalRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #801950;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #801950;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 25.66px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.07,438.02H426.93c25.81,0,45.72-22.74,42.29-48.33l-28.65-214.04c-2.84-21.19-20.91-37.01-42.29-37.01H119.59c-20.94,0-38.79,15.2-42.13,35.88l-34.52,214.04c-4.18,25.94,15.85,49.46,42.13,49.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.75,264.79h-64.15c-2.81,0-5.09-2.28-5.09-5.09v-64.15c0-4.39-3.56-7.95-7.95-7.95h-34.48c-4.39,0-7.95,3.56-7.95,7.95v64.15c0,2.81-2.28,5.09-5.09,5.09h-64.15c-4.39,0-7.95,3.56-7.95,7.95v34.48c0,4.39,3.56,7.95,7.95,7.95h64.15c2.81,0,5.09,2.28,5.09,5.09v64.15c0,4.39,3.56,7.95,7.95,7.95h34.48c4.39,0,7.95-3.56,7.95-7.95v-64.15c0-2.81,2.28-5.09,5.09-5.09h64.15c4.39,0,7.95-3.56,7.95-7.95v-34.48c0-4.39-3.56-7.95-7.95-7.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.32,138.64c25.2-43.36,72.39-68.48,120.57-64.18,63.37,5.65,95.11,59.21,97.94,64.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalRecord);
export default __webpack_public_path__ + "static/media/clinical_record.510f69dbb5148c1dc8137ecbaca09a5f.svg";
export { ForwardRef as ReactComponent };